import React, { createContext, useContext, useState, useEffect } from "react";
import deTranslations from "../translations/de";
import enTranslations from "../translations/en";
import elTranslations from "../translations/el";
import bgTranslations from "../translations/bg";

// Available languages with their labels
export const languages = {
  de: { code: "de", name: "Deutsch", translations: deTranslations },
  en: { code: "en", name: "English", translations: enTranslations },
  el: { code: "el", name: "Ελληνικά", translations: elTranslations },
  bg: { code: "bg", name: "Български", translations: bgTranslations },
};

const LanguageContext = createContext();

export const useLanguage = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }) => {
  // Default language is German
  const [currentLanguage, setCurrentLanguage] = useState(() => {
    const savedLanguage = localStorage.getItem("language");
    return savedLanguage && languages[savedLanguage] ? savedLanguage : "de";
  });

  // Save language preference to localStorage when it changes
  useEffect(() => {
    localStorage.setItem("language", currentLanguage);
  }, [currentLanguage]);

  // Get the current translations
  const translations = languages[currentLanguage].translations;

  // Translate function
  const t = (key) => {
    return translations[key] || key;
  };

  // Change language
  const changeLanguage = (langCode) => {
    if (languages[langCode]) {
      setCurrentLanguage(langCode);
    }
  };

  const contextValue = {
    currentLanguage,
    languages,
    t,
    changeLanguage,
  };

  return (
    <LanguageContext.Provider value={contextValue}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;
